// GA4 add_to_cart — s'abonne au pubsub Dawn cart-update
document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe === 'function') {
    subscribe('cart-update', function (data) {
      if (data && data.source === 'product-form') {
        try {
          var items = [];
          if (data.cartData && data.cartData.items) {
            items = data.cartData.items.map(function (item) {
              return {
                item_id: String(item.product_id),
                item_name: item.product_title,
                price: (item.price / 100).toFixed(2),
                quantity: item.quantity,
              };
            });
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency:
                window.Shopify && window.Shopify.currency
                  ? window.Shopify.currency.active
                  : 'EUR',
              items: items,
            },
          });
        } catch (e) {}
      }
    });
  }
});

// Clic interne article -> fiche produit.
//
// POURQUOI. C'est le seul passage du site qui n'etait mesure par rien. L'event GA4 `click`
// ne compte que les liens SORTANTS ; le seul substitut, `pageReferrer`, rate environ 42 %
// du trafic multi-pages. Audit du 2026-08-12 : 29 passages mesures sur 30 jours, contre un
// reel estime autour de 50. Sans cet event, l'indicateur « vues de fiche issues d'un
// article » reste pilote a l'aveugle.
//
// CE QUE CE CODE NE FAIT PAS, volontairement :
//  - il n'appelle jamais preventDefault : la navigation n'est pas touchee ;
//  - il n'emet PAS d'objet `ecommerce` ni l'event standard `select_item`. Un `item_id`
//    deduit du handle d'URL ne correspondrait pas a celui de `view_item` (qui utilise le
//    product_id) et polluerait les rapports produit de GA4. On emet donc un event custom
//    a parametres plats, impossible a confondre avec le e-commerce natif ;
//  - il n'attend rien de GTM : sans tag en face, le push est inerte.
//
// PREREQUIS pour que la mesure existe : un declencheur GTM sur `article_to_product` et un
// tag GA4 Event associe. Tant qu'ils n'existent pas, ce code ne coute qu'un ecouteur.
document.addEventListener(
  'click',
  function (e) {
    try {
      if (!e.target || !e.target.closest) return;
      var a = e.target.closest('a[href]');
      if (!a) return;

      // Depart : une page editoriale uniquement. Un clic depuis une collection ou depuis
      // une autre fiche n'est pas le passage qu'on cherche a mesurer.
      if (window.location.pathname.indexOf('/blogs/') !== 0) return;

      // Arrivee : une fiche produit du meme domaine. `a.href` est resolu par le navigateur,
      // ce qui neutralise les chemins relatifs et les liens vers un autre hote.
      var url;
      try {
        url = new URL(a.href, window.location.origin);
      } catch (err) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (url.pathname.indexOf('/products/') === -1) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'article_to_product',
        article_path: window.location.pathname,
        product_path: url.pathname,
        // Distingue un lien dans le corps du texte d'un bloc de fin : la mesure du 12/08
        // montre 9,3 % de passage pour un lien inline contre 0 % pour un bloc de fin seul.
        link_placement: a.closest('.sd-product-card, .sd-cta, [data-product-block]')
          ? 'bloc'
          : 'inline',
      });
    } catch (err) {
      /* la mesure ne doit jamais casser une navigation */
    }
  },
  true // capture : passe avant un eventuel stopPropagation d'un composant Dawn
);

// Prefetch des liens internes visibles (navigation instantanee).
//
// SEULEMENT des pages de navigation : accueil, fiche, collection, page, blog, sans parametre.
// Un prefetch est une vraie requete GET, et Shopify AGIT sur certains GET :
// `/cart/change?id=...&quantity=0` (le lien « retirer » de la page panier) vide la ligne,
// `/account/logout` deconnecte. Constate le 2026-10-21 : sur telephone, ouvrir /cart videait le
// panier, le lien « retirer » etant parmi les cinq premiers liens visibles (sur ordinateur, ceux
// de l'en-tete passaient avant lui). Tenu par scripts/test/prefetch-sans-effet.test.mjs.
var PREFETCH_AUTORISE = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:products|collections|pages|blogs)\/[^?#]+)?$/;
document.addEventListener('DOMContentLoaded', function () {
  var prefetched = new Set();
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var href = entry.target.getAttribute('href');
          if (
            href &&
            PREFETCH_AUTORISE.test(href) &&
            !prefetched.has(href) &&
            prefetched.size < 5
          ) {
            var link = document.createElement('link');
            link.rel = 'prefetch';
            link.href = href;
            document.head.appendChild(link);
            prefetched.add(href);
          }
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '200px' }
  );
  document.querySelectorAll('a[href^="/"]').forEach(function (a) {
    observer.observe(a);
  });
});
